<template>
    <div :style="{height: this.tableData.length === 0 ? '100vh' : 'auto'}">
    <Nav :isDark.sync="this.isDark" @darkmode="isDark = $event"></Nav>
    <div :class="this.isphone ? '' : 'container'" :style="{height: this.tableData.length === 0 ? 'calc(100vh - 73px)' : 'auto'}">
        <el-backtop></el-backtop>
        <div class="d-flex justify-content-center" :class="{'h-100':this.tableData.length === 0}" v-if="!this.isphone">
            <div :style="{width: this.ispad ? '100%' : '1080px'}">
                <div class="d-flex justify-content-between align-items-center my-2" :style="{width: this.ispad ? '100%' : '1080px',margin: '0 auto'}">
                    <span class="fs-4" v-if="this.dateParams !== undefined && this.dateParams !== ''">{{ this.dateStr }}</span>
                    <div v-if="this.dateParams == undefined || this.dateParams == ''">
                        <span>日期：</span>
                        <el-date-picker
                            v-model="dateVal"
                            type="date"
                            placeholder="选择日期"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            @change="changeDate">
                        </el-date-picker>
                    </div>
                    <div>
                        <el-button plain type="primary" @click="hideNoData">剔除无数据</el-button>
                    </div>
                </div>
                <ux-grid
                ref="table"
                stripe
                show-overflow
                use-virtual
                :widthResize = 'true'
                :empty-text = this.emptyText
                :data = tableData
                :highlightCurrentRow="true"
                show-header-overflow="ellipsis">
                    <!-- <ux-table-column type="checkbox" :width="40"/> -->
                    <ux-table-column type="index" :width="50"/>
                    <ux-table-column width="8%" field="name" title="联赛" :filters="filters" :filter-method="filterTag">
                        <template v-slot="scope">
                            <div class="text-white text-center fs-12 rounded" :style="{background: scope.row.color}">{{ lgName1(scope.row.name)}} <br> {{ lgName2(scope.row.name)}}</div>
                        </template>
                    </ux-table-column>
                    <ux-table-column width="7%" field="time" title="时间">
                        <template v-slot="scope">
                            <div class="d-flex flex-column justify-content-start fs-12" style="line-height: normal;">
                                <span>{{scope.row.date}}</span>
                                <span>{{scope.row.time}}</span>
                            </div>
                        </template>
                    </ux-table-column>
                    <ux-table-column field="home" title="球队" :width="this.isphone ? 150 : ''">
                        <template v-slot="scope">
                            <div class="d-flex flex-column">
                                <div>
                                    <router-link :to="{ path: '/bsk-detail/' + scope.row.id, query: { teams: scope.row.home+' VS '+scope.row.away,hxg:scope.row.hxg, axg:scope.row.axg } }" class="my-2 text-decoration-none" target="_blank">{{ scope.row.home }}</router-link>
                                    <sup><font>{{ scope.row.homerank }}</font></sup>
                                </div>
                                <div>
                                    {{ scope.row.away }}
                                    <sup><font>{{ scope.row.awayrank }}</font></sup>
                                </div>
                            </div>
                        </template>
                    </ux-table-column>
                    <ux-table-column :width="86" field="handicap" title="让分">
                        <template v-slot="scope">
                                    <div class="d-flex justify-content-center">
                                        <span style="width: 30px; margin-right: 8px;">{{ odd1Val(scope.row.handicap) }}</span>
                                        <span style='color:#880000;'>{{ scope.row.index1 }}</span>
                                    </div>
                                    <div class="d-flex justify-content-center">
                                        <span style="width: 30px; margin-right: 8px;">{{ odd2Val(scope.row.handicap) }}</span>
                                        <span style='color:#880000;'>{{ scope.row.index2 }}</span>
                                    </div>
                        </template>
                    </ux-table-column>
                    <ux-table-column :width="130" field="index1" title="总分">
                        <template v-slot="scope">
                            <div class="d-flex">
                                <div class="d-flex flex-column">
                                    <span v-if="scope.row.big !== ''">大</span>
                                    <span v-if="scope.row.small !== ''">小</span>
                                </div>
                                <div class="flex flex-column">
                                    <div>
                                        <span class="mx-3">{{ scope.row.bigsmall }}</span>
                                        <span style='color:#880000;'>{{ scope.row.big }}</span>
                                    </div>
                                    <div>
                                        <span class="mx-3">{{ scope.row.bigsmall }}</span>
                                        <span style='color:#880000;'>{{ scope.row.small }}</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </ux-table-column>
                    <ux-table-column :width="80" field="qsda" title="窄实">
                        <template v-slot="scope">
                            <a :href="'https://nba.titan007.com/analysis/'+scope.row.id+'.htm'" target='_blank' class="text-decoration-none font-weight-bold">
                                <span class="qsda qsdaColor" :style="{color: qsdaColorSet(scope.row.handicap,scope.row.qsda)}">{{ scope.row.qsda === null || scope.row.hxg+scope.row.axg === 0 ? '' : qsdaVal(scope.row.hxg - scope.row.axg) }}</span>
                            </a>
                        </template>
                    </ux-table-column>
                    <ux-table-column :width="80" field="bs" title="火力值">
                        <template v-slot="scope">
                            <a :href="'https://nba.titan007.com/analysis/'+scope.row.id+'.htm'" target='_blank' class="text-decoration-none font-weight-bold">
                                <span class="qsda qsdaColor" :style="{color: bsColorSet(scope.row.bigsmall,scope.row.hxg+scope.row.axg)}">{{ scope.row.qsda === null || scope.row.hxg+scope.row.axg === 0 ? '' : bbBsVal(scope.row.hxg+scope.row.axg) }}</span>
                            </a>
                        </template>
                    </ux-table-column>
                    <ux-table-column :width="80" field="qsda" title="qsda">
                        <template v-slot="scope">
                            <a :href="'https://nba.titan007.com/analysis/'+scope.row.id+'.htm'" target='_blank' class="text-decoration-none font-weight-bold">
                                <span class="qsda qsdaColor" :style="{color: qsdaColorSet(scope.row.handicap,scope.row.qsda)}">{{ scope.row.qsda === null ? '' : parseFloat(scope.row.qsda*100).toFixed(0) }}</span>
                            </a>
                        </template>
                    </ux-table-column>
                </ux-grid>
            </div>
        </div>
        <div v-if="this.isphone" style="margin-top: 40px;">
            <div class="d-flex justify-content-between align-items-center border-bottom py-1 px-2 bg-light">
                <el-button class="fs-12 py-0 text-primary" type="text" @click="centerDialogVisible = true">联赛选择</el-button>
            </div>
            <el-dialog title="联赛选择" :visible.sync="centerDialogVisible" width="90%" center>
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                <div style="max-height: 50vh; overflow-y: scroll;">
                    <el-checkbox-group v-model="checkedLeague" @change="handleCheckedLeagueChange">
                        <el-checkbox v-for="(item,index) in league" :label="item" :key="index" :checked="isHide[index]" @change="change(isHide[index],item)">{{item}}</el-checkbox>
                    </el-checkbox-group>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
                </span>
            </el-dialog>
            <div v-for="(item,index) in tableData" :key="index">
                <div :class="{'d-none': isHide[index]}">
                    <div class="d-flex justify-content-between align-items-center py-2 border-bottom px-2">
                    <div class="d-flex flex-column">
                        <div>
                        <span class="fs-10 me-3" :style="{ color: item.color }">{{ item.name }}</span>
                        <span class="fs-10 time me-2 text-black-50">{{ item.date }}</span>
                        <span class="fs-10 time text-black-50">{{ item.time }}</span>
                        </div>
                        <div class="d-flex">
                            <!-- <button class="btn ps-0" @click="addOrDelFav(index,item)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" v-show="!isFav[index].selected" fill="#eee" class="bi bi-star-fill" viewBox="0 0 16 16">
                                <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" v-show="isFav[index].selected" fill="#ffc107" class="bi bi-star-fill" viewBox="0 0 16 16">
                                <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                            </svg>
                            </button> -->
                            <div class="d-flex flex-column">
                                <span>
                                    <b class="fs-14">{{ item.home }}</b>
                                    <font class="fs-12 ms-1">{{ item.homeRank }}</font>
                                </span>
                                <span>
                                    <b class="fs-14">{{ item.away }}</b>
                                    <font class="fs-12 ms-1">{{ item.awayRank }}</font>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-column pe-1">
                        <span class="fs-10 d-flex justify-content-end align-items-center" style="height: 24px;">
                        <router-link :to="{ path: '/charts/' + item.m_id, query: { teams: item.home+' VS '+item.away } }" class="text-decoration-none ms-2" tag="a" target="_blank">
                            <i class="el-icon-s-data fs-12" style="color: #ccc;"></i>
                        </router-link>
                        </span>
                        <div class="d-flex" style="height: 48px;">
                        <div class="d-flex flex-column align-items-end justify-content-center">
                            <span class="fs-12 text-primary">{{ item.handicap !== '' ?  '让: ' + item.handicap : item.handicap }}</span>
                            <span class="fs-12 mt-1 text-primary">{{ item.bigsmall !== '' ?  '总: ' + item.bigsmall : item.bigsmall }}</span>
                        </div>
                        <a class="text-decoration-none d-flex flex-column justify-content-center align-items-end" :href="'https://m.titan007.com/Analy/ShiJian/'+item.m_id+'.htm'" target="_blank" style="width: 48px;">
                            <b class="fs-14 ps-3 qsdaColor" :style="{color: qsdaColorSet(item.handicap,item.qsda)}">{{ qsdaVal(item.qsda) }}</b>
                        </a>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        <Footer></Footer>
    </div>
</template>
<script>
// import jsonData from '@/data/tomorrow.json';
// eslint-disable-next-line no-unused-vars
import {setcolor } from '@/utils/setcolor';
import { dateFormatted, isMobile,bbBsVal } from '../utils/utils';
import Nav from './comment/nav.vue'
import Footer from './comment/footer.vue'
export default {
    inject: ['reload'],
    components: { Nav,Footer },
    data() {
        return {
            tableData: [],
            filters: [],
            myLeague1: [],
            myLeague2: [],
            ishide: [],
            selectedFilters: [],
            checkedLeague: [],
            league: [],
            isHide: [],
            odd1: '',
            odd2: '',
            emptyText: '数据加载中...',
            columns: [
                { label: '联赛', prop: 'name' },
                { label: '时间', prop: 'time' },
                { label: '主排名', prop: 'homeRank' },
                { label: '主队', prop: 'home' },
                { label: 'qsda', prop: 'qsda' },
                { label: '客队', prop: 'away' },
                { label: '客排名', prop: 'awayRank' },
                { label: '指数1', prop: 'index1' },
                { label: 'Crow', prop: 'handicap' },
                { label: '指数2', prop: 'index2' },
                { label: '小球', prop: 'small' },
                { label: '大小', prop: 'bigsmall' },
                { label: '大球', prop: 'big' },
                { label: 'id', prop: 'id' },
            ],
            isDark: false,
            isToday: true,
            isTomorrow: false,
            loading: true,
            isIndeterminate: false,
            centerDialogVisible: false,
            checkAll: true,
            dateStr: '',
            currentDate: 0,
            dateParams: '',
            isphone: false,
            ispad: false,
            dateVal: ''
        }
    },
    mounted() {
        // console.log(this.$route.params.date);
        this.dateParams = this.$route.params.date;
        this. dateStr = this.$route.params.date;
        this.loadData();
        if(this.isMobile() === 'mobile'){
            this.isphone = true;
        }
        if(this.isMobile() === 'tablet'){
            this.ispad = true;
        }
    },
    methods: {
        setcolor,
        dateFormatted,
        isMobile,
        bbBsVal,
        //请求数据
        fetchData(url){
            fetch(url)
            .then(response => response.json())
            .then(data => {
                    console.log(data.data);
                    if (data.code == 200) {
                        this.dateStr = data.data.length > 0 ? data.data[0].date : ''
                        this.tableData = data.data;
                        
                        const leagueSet = new Set(this.tableData.map((item) => item.name));
                        const leagueArray = Array.from(leagueSet);
                        this.league = leagueArray.map((item) => (item));
                        this.checkedLeague = this.league;
                        // const lgTotalNum = this.tableData.reduce((sum, item) => sum + Number(item.mNum), 0);
                        // const lgTotalget = this.tableData.reduce((sum, item) => sum + Number(item.totalGet), 0);
                        // const lg_avg_get = Number(parseFloat(lgTotalget/lgTotalNum).toFixed(2));
                        //联赛显示隐藏状态赋值
                        for (let index = 0; index < this.tableData.length; index++) {
                            this.isHide.push(false);
                            // if (this.tableData[index].name.includes('季后')) {
                            //     console.log('000',this.tableData[index].eqGet);
                            //     this.tableData[index].eqGet = this.tableData[index].totalGet / this.tableData[index].mNum;
                            //     this.tableData[index].eqLoss = this.tableData[index].totalLoss / this.tableData[index].mNum;
                            //     this.tableData[index].lg_avg_get = lg_avg_get;
                            //     this.tableData[index].atr = Number(parseFloat(this.tableData[index].eqGet / lg_avg_get).toFixed(2));
                            //     this.tableData[index].def = Number(parseFloat(this.tableData[index].eqLoss / lg_avg_get).toFixed(2));
                            //     console.log(this.tableData[index].name,this.tableData[index].eqGet);
                            // }
                        }
                        if (this.tableData.length == 0) {
                            this.emptyText = '暂无数据';
                        }else{
                            this.emptyText = '加载中...';
                        }
                        if (!this.isphone) {
                            this.$refs.table.reloadData(this.tableData);
                            this.updateFilterEvent()
                        }
                        this.loading = false;
                    }else{
                        this.emptyText = '暂无数据';
                        this.loading = false;
                    }
            })
            .catch(error => {
                console.error('Error:', error)
                this.emptyText = '暂无数据';
                this.loading = false;
            });
        },
        loadData(){
            let date = dateFormatted(new Date());
            this.dateVal = date;
            if (this.dateParams !== undefined) {
                date = this.dateParams;
            }else{
                // 设置目标时间为 10:30 AM
                let targetTime = new Date();
                let currentTime = new Date();
                targetTime.setHours(10);
                targetTime.setMinutes(35);
                targetTime.setSeconds(0);
                // 比较当前时间和目标时间
                if (currentTime > targetTime) {
                    console.log("当前时间大于 10:35 AM，读取今日数据");
                    date = this.dateFormatted(currentTime);
                } else {
                    console.log("当前时间小于 10:35 AM，读取昨天数据");
                    // 将日期减一天
                    currentTime.setDate(currentTime.getDate() - 1)
                    date = this.dateFormatted(currentTime);
                    // console.log(dateParams);
                }
            }
            const url = '/basketball/match/'+date;
            // const url = '/match/date/' + date;
            this.fetchData(url);
        },
        //qsda颜色设置
        qsdaColorSet(handicap,qsda){
            // console.log(handicap,qsda);
            let txtcolor = '#8000ff';
            if (handicap == '') {
                txtcolor = '#8000ff'
            }else{
                if (Number(handicap) == this.qsdaVal(qsda)) {
                    txtcolor = 'black';
                }
                if (Number(handicap) >= 0) {
                    if (Number(handicap) > this.qsdaVal(qsda)) {
                        txtcolor = 'red';
                    }
                    if (Number(handicap) < this.qsdaVal(qsda)) {
                        txtcolor = 'green';
                    }
                }else{
                    if (Number(handicap) < this.qsdaVal(qsda)) {
                        txtcolor = 'red';
                    }
                    if (Number(handicap) > this.qsdaVal(qsda)) {
                        txtcolor = 'green';
                    }
                }
                
            }
            return txtcolor;
        },
        bsColorSet(bs,bsVal){
            let txtcolor = '#8000ff';
            if (bs == '') {
                txtcolor = '#8000ff'
            }else{
                if (Number(bs) == this.bbBsVal(bsVal)) {
                    txtcolor = 'black';
                }
                if (Number(bs) > this.bbBsVal(bsVal)) {
                    txtcolor = 'red';
                }
                if (Number(bs) < this.bbBsVal(bsVal)) {
                    txtcolor = 'green';
                }
            }
            return txtcolor;
        },
        //pc过滤联赛
        filterTag({value, row, column}) {
            const property = column['property'];
            console.log(property,column['property'],value,row);
            return row[property] === value;
        },
        //更新联赛过滤列表
        updateFilterEvent(){
            const column = this.$refs.table.getColumnByField('name')
            const leagueSet = new Set(this.tableData.map((item) => item.name));
            const leagueArray = Array.from(leagueSet);
            this.filters = leagueArray.map((item) => ({ label: item, value: item }));
            this.$refs.table.setFilter(column, this.filters)
            this.$refs.table.updateData()
        },
        //让球
        odd1Val(hd){
            if (Number(hd)<0) {
                return '';
            }else{
                return hd;
            }
        },
        //受球
        odd2Val(hd){
            if (Number(hd)<0) {
                return hd.split('-')[1];
            }else{
                return '';
            }
        },
        //日期
        lgName1(name){
            if (name.includes(' ')) {
                return name.split(' ')[0]
            }else{
                return name
            }
        },
        //时间
        lgName2(name){
            if (name.includes(' ')) {
                return name.split(' ')[1]
            }else{
                return ''
            }
        },
        //qsda换算
        qsdaVal(value){
            // 保留两位小数
            const roundedValue = Math.round(value * 100) / 100;
            const decimalPart = roundedValue % 1; // 获取小数部分

            if (decimalPart === 0) {
                return roundedValue; // 整数部分直接返回
            }

            if (roundedValue > 0) {
                // 对正数处理
                if (decimalPart <= 0.25) {
                    return Math.floor(roundedValue); // 小数 <= 0.25 算 0
                } else if (decimalPart > 0.25 && decimalPart <= 0.75) {
                    return Math.floor(roundedValue) + 0.5; // 小数 > 0.25 且 <= 0.75 算 0.5
                } else {
                    return Math.ceil(roundedValue); // 小数 > 0.75 算 1
                }
            } else {
                // 对负数处理
                if (decimalPart >= -0.25) {
                    return Math.ceil(roundedValue); // 小数 >= -0.25 算 0
                } else if (decimalPart < -0.25 && decimalPart >= -0.75) {
                    return Math.ceil(roundedValue) - 0.5; // 小数 < -0.25 且 >= -0.75 算 -0.5
                } else {
                    return Math.floor(roundedValue); // 小数 < -0.75 算 -1
                }
            }
        },
        //过滤联赛
        handleCheckedLeagueChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.league.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.league.length;
        },
        //全选联赛
        handleCheckAllChange(val) {
            this.checkedLeague = val ? this.league : [];
            this.checkMyLeague1 = false;
            this.checkMyLeague2 = false;
            this.isIndeterminate = false;
            //设置全选或全不选      
            for (let index = 0; index < this.isHide.length; index++) {
                if (val) {
                this.isHide[index] = false;
                }else{
                this.isHide[index] = true;
                }
            }
        },
        change(val,name){
            console.log(val,name,this.tableData.length,this.isHide.length);
            // this.isHide[index] = !this.isHide[index];
            for (let index = 0; index < this.tableData.length; index++) {
                const elm = this.tableData[index].name;
                // console.log('000',elm,this.isHide[index]);
                if (name === elm) {
                this.isHide[index] = !this.isHide[index];
                // console.log(index+1,elm,this.isHide[index]);
                }
            }
        },
        changeDate(){
            const date = this.dateVal;
            this.tableData = [];
            const url = '/basketball/match/'+date;
            this.fetchData(url)
        },
        hideNoData(){
            // 剔除没xg数据的
            const filterdata = this.tableData.filter(item =>(item.hxg !== 0 && item.hxg !== null) && (item.axg !== 0 && item.axg !== null));
            this.tableData = filterdata;
            this.$refs.table.reloadData(this.tableData);
        }
    },
}
</script>
<style lang="scss" scoped>
    @import '../assets/sass/global.scss';
    .container,.container-fluid {padding-bottom: 60px;}
    font {color: rgb(136, 136, 136);}
    ::v-deep .elx-body--row .col_2 .elx-cell {padding: 0;}
    ::v-deep .elx-header--row .col_3 .elx-cell {justify-content: center;}
    ::v-deep .elx-header--row .col_5 .elx-cell {justify-content: left;}
    ::v-deep .elx-header--row .col_6 .elx-cell {justify-content: center;}
    ::v-deep .elx-header--row .col_7 .elx-cell {justify-content: center;}
    ::v-deep .elx-header--row .col_8 .elx-cell {justify-content: center;}
    ::v-deep .elx-table--body-wrapper {font-size: 16px; color: #000;}
    // ::v-deep .col_3 .elx-cell {padding: 0;}
    ::v-deep .elx-body--column { text-align: center!important; }
    ::v-deep .col_5 { text-align: left!important; }
    ::v-deep .col_5 { padding: 8px 0!important; }
    ::v-deep .col_7 { text-align: left!important; }
    // ::v-deep .elx-table.border--full .elx-table--header-wrapper { background-color: #82959f;}
    // ::v-deep .elx-header--column .elx-cell { color: #fff; }
    ::v-deep .elx-table .elx-header--column.col--ellipsis {height: auto;padding: 5px 0;}
    .nodata {
            color: #ccc;
        }
    .NIGHT {
        .nodata {
            color: #666;
        }
    }
</style>